module.exports = __webpack_public_path__ + "img/signature_1.9e94faa7.png";